//component/UserPrivateRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "../../../context/UserContext";

const UserPrivateRoute = () => {
  const { currentUser, loading } = useUser();
  // const location = useLocation(); // Commented out as it's not used

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!currentUser) {
    // Redirect to login but save where they were going
    return <Navigate to="/" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default UserPrivateRoute;
